import type { ComponentProps } from 'react';
import { cn } from '@/ui-kit/utils';

export const ButtonStack = ({ className, ...props }: ComponentProps<'div'>) => (
  <div className={cn('flex flex-col gap-2', className)} {...props} />
);
